module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "home_index",
    staticClass: "home_index"
  }, [_c('div', {
    staticClass: "index_box"
  }, [_c('div', {
    staticClass: "concernlist_box"
  }, [_c('div', {
    staticClass: "concernlist_tit"
  }, [_vm._v("我关注的")]), _vm._v(" "), _c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了",
      "immediate-check": false
    },
    on: {
      "load": _vm.getMyExamList
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.listData), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "concernlist",
      on: {
        "click": function($event) {
          return _vm.gotodetail(item.id)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', [_vm._v("提醒方式：" + _vm._s(item.remind))])])
  }), 0)], 1)]), _vm._v(" "), _c('tab-bar', {
    attrs: {
      "current-index": 0
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-716869ed"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/page/myconcerned.vue
// module id = 700
// module chunks = 1